import {
  Alert,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const AcceptanceChecklist = ({
  checklist = [],
  missingRequirements = [],
}) => (
  <Stack spacing={1.5} data-testid="acceptance-checklist">
    <Typography variant="subtitle1" fontWeight={700}>
      چک‌لیست پذیرش
    </Typography>
    {!checklist.length ? (
      <Alert severity="info">موردی برای نمایش وجود ندارد.</Alert>
    ) : (
      <List dense disablePadding>
        {checklist.map((item) => (
          <ListItem
            key={`${item.itemCode}-${item.itemTitle}`}
            data-testid={`acceptance-item-${item.itemCode}`}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              {item.isPassed ? (
                <CheckCircleOutlineIcon color="success" fontSize="small" />
              ) : (
                <RadioButtonUncheckedIcon color="disabled" fontSize="small" />
              )}
            </ListItemIcon>
            <ListItemText
              primary={item.itemTitle || item.itemCode}
              secondary={
                item.isRequired
                  ? item.isPassed
                    ? "تکمیل شده"
                    : "الزامی — ناقص"
                  : null
              }
            />
          </ListItem>
        ))}
      </List>
    )}
    {missingRequirements.length ? (
      <Alert severity="warning" data-testid="acceptance-missing">
        موارد ناقص: {missingRequirements.join("، ")}
      </Alert>
    ) : (
      <Alert severity="success" data-testid="acceptance-complete">
        همه موارد الزامی تکمیل شده‌اند (تأیید نهایی فقط توسط سولارنت).
      </Alert>
    )}
  </Stack>
);

export default AcceptanceChecklist;
